$(document).ready(function(){
    // $('.announcement-bar-section').addClass('custom_class');

  // hover effect for section--> why--flebo
  $('.js-hover-fade').each(function() {
    var $blueImage = $(this).find('.blue-image');
    var $redImage = $(this).find('.red-image');

    $(this).hover(
      function() {
        $blueImage.stop().animate({'opacity': '0'}, 400);
        $redImage.stop().animate({'opacity': '1'}, 400);
      },
      function() {
        $blueImage.stop().animate({'opacity': '1'}, 400);
        $redImage.stop().animate({'opacity': '0'}, 400);
      }
    );
  });



   $('.findSupplements__slider.carousel').slick({
    slidesToShow: 4,
    dots: false,
    centerMode: false,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false, // Ensure navigation arrows are visible
      responsive: [
          {
            breakpoint: 1280,
            settings: {
              slidesToShow: 4
            }
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 4
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 3
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 2
            }
          }
      ]
  });

  

  

  // $('.rtl-slider').slick({
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  //   arrows: false,
  //   fade: true,
  //   asNavFor: '.rtl-slider-nav'
  // });
  // $('.rtl-slider-nav').slick({
  //   slidesToShow: 4,
  //   slidesToScroll: 1,
  //   vertical:true,
  //   arrows: true,
  //   asNavFor: '.rtl-slider',
  //   centerMode: false,
  //   focusOnSelect: true,
  //   prevArrow: ".thumb-prev",
  //   nextArrow: ".thumb-next",

  //      responsive: [
  //       {
  //         breakpoint: 772,
  //         settings: {
  //           slidesToShow: 5,
  //           vertical: false,
  //         }
  //       }, {
  //         breakpoint: 480,
  //         settings: {
  //           slidesToShow: 3,
  //           vertical: false,
  //         }
  //       }
        
  //   ]
  // });



$(document).ready(function(){
  // Main gallery slider
  $('.horizontal-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.horizontal-slider-nav'
  });

  // Thumbnail navigation slider
  $('.horizontal-slider-nav').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    asNavFor: '.horizontal-slider',
    centerMode: false,
    focusOnSelect: true,
    prevArrow: ".thumb-prev-horizontal",
    nextArrow: ".thumb-next-horizontal",
    responsive: [
      {
        breakpoint: 772,
        settings: {
          slidesToShow: 5,
          vertical: false
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
          vertical: false
        }
      }
    ]
  });
});











  //This is for animation on scroll
    AOS.init();


  $('.video__slider').slick({
  slidesToShow: 4,
  dots: false,
  centerMode: false,
  autoplay: false,
  autoplaySpeed: 3000,
  arrows: true, // Navigation arrows
  responsive: [
    {
      breakpoint: 1280,
      settings: {
        slidesToShow: 4
      }
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1
      }
    }
  ]
});
  




//   $('.howFlebo__slider').slick({
//   slidesToShow: 7,
//   dots: false,
//   centerMode: false,
//   autoplay: true,
//   autoplaySpeed: 2000,
//   arrows: false, // Navigation arrows
//   responsive: [
//     {
//       breakpoint: 1280,
//       settings: {
//         slidesToShow: 7
//       }
//     },
//     {
//       breakpoint: 1024,
//       settings: {
//         slidesToShow: 6
//       }
//     },
//     {
//       breakpoint: 767,
//       settings: {
//         slidesToShow: 5
//       }
//     },
//     {
//       breakpoint: 480,
//       settings: {
//         slidesToShow: 4
//       }
//     }
//   ]
// });




//    $('.supplementary__imageSlider').slick({
//   slidesToShow: 5,
//   dots: false,
//   centerMode: true,
//   autoplay: true,
//   autoplaySpeed: 3000,
//   arrows: false, // Navigation arrows
//   responsive: [
//     {
//       breakpoint: 1280,
//       settings: {
//         slidesToShow: 5
//       }
//     },
//     {
//       breakpoint: 1024,
//       settings: {
//         slidesToShow: 4
//       }
//     },
//     {
//       breakpoint: 767,
//       settings: {
//         slidesToShow: 3
//       }
//     },
//     {
//       breakpoint: 480,
//       settings: {
//         slidesToShow: 2
//       }
//     }
//   ]
// });


  
});
// $(document).ready(function(){
// var currentUrl = $(location).attr('href');
// console.log(currentUrl);

//   });